export default {"src":"/_next/static/media/limes.89ac9128.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};